module.exports = __webpack_public_path__ + "aryeo-logo-bc2ec0c8b87b7112d183440bd60c58f3.svg";